import { createStore } from 'vuex'

export default createStore({
  state: {
    locale: 'en',
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
